import slugs from "navigation/slugs";
import { VideoCameraIcon, GiftIcon } from "@heroicons/react/24/outline";
import { ReactComponent as Live } from "assets/icons/live.svg";

export const navigations = [
  {
    name: "Home",
    href: slugs.home,
    icon: "text-lg fa-house",
  },

  {
    name: "Explore",
    href: slugs.explore,
    icon: "text-lg fa-bolt",
  },

  {
    name: "",
    href: slugs.upload,
    icon: "text-lg fa-plus-large",
  },

  {
    name: "Inbox",
    href: slugs.inbox,
    icon: "text-lg fa-inbox",
  },

  {
    name: "Profile",
    href: slugs.profile,
    icon: "text-lg fa-user",
  },
];
export const uploadFeatures = [
  { name: "Videos", icon: VideoCameraIcon },
  { name: "Perks", icon: GiftIcon },
  { name: "Livestream", icon: Live },
];

export const tabs = [{ name: "Stream" }, { name: "Perks" }];

export const activityTabs = [
  { name: "Activities" },
  { name: "Trades" },
  { name: "Holders" },
  { name: "Holdings" },
];

export const inboxTabs = [
  {
    name: "Chat",
  },
  {
    name: "Activities",
  },
  {
    name: "Subscribed",
  },

  {
    name: "System",
  },
];

export const pointRewards = [
  { action: "📹 Upload Videos", point: "20" },
  { action: "👀 Watch 1 Video", point: "1" },
  { action: "👀 Watch 10+ Videos", point: "+2/video" },
  { action: "👍 Like", point: "2" },
  { action: "🔁 Repost", point: "5" },
  { action: "💬 Comment (≥4 words)", point: "5" },
  { action: "⤴ Share on other platforms", point: "10" },
  { action: "🔔 Log in daily", point: "5" },
  { action: "🕕 Upload daily", point: "5" },
  { action: "🤝 Refer a friend", point: "50" },
];

export const homeTabs = [
  { name: "Trending" },
  { name: "Upcoming" },
  { name: "Following" },

  // { name: "New" },
];

export const exploreTabs = [
  { name: "On fan.tech" },
  { name: "On TikTok" },

  // { name: "New" },
];
